'use strict';

exports.__esModule = true;
/**
 * add Vue-Router support
 */

exports.default = {
    props: {
        url: String,
        replace: Boolean,
        to: [String, Object]
    },

    methods: {
        routerLink: function routerLink() {
            var to = this.to,
                url = this.url,
                $router = this.$router,
                replace = this.replace;

            if (to && $router) {
                $router[replace ? 'replace' : 'push'](to);
            } else if (url) {
                // eslint-disable-next-line
                replace ? location.replace(url) : location.href = url;
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@tuniu/dpl-vui/lib/mixins/router-link.js
// module id = 481
// module chunks = 22